<template>
  <div class="positioning-seat-step-one">
    <v-layout justify-center>
      <v-flex
        column
        sm8
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_selle_positionnement_1a.svg">
            <v-text-field
              v-model="form.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A"
              :class="{ error: errors.has('(Schéma) A') }"
              outlined
              type="number"
              label="mm"
              style="top: 61.6%;left: 0.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B"
              :class="{ error: errors.has('(Schéma) B') }"
              outlined
              type="number"
              label="mm"
              style="top: 48.6%;left: 8.8%;"
              height="100%"
            />
            <v-text-field
              v-model="form.c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C"
              :class="{ error: errors.has('(Schéma) C') }"
              outlined
              type="number"
              label="mm"
              style="top: 28.1%;left: 32.9%;"
              height="100%"
            />
            <v-text-field
              v-model="form.d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D"
              :class="{ error: errors.has('(Schéma) D') }"
              outlined
              type="number"
              label="mm"
              style="top: 45.6%;left: 35.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) E"
              :class="{ error: errors.has('(Schéma) E') }"
              outlined
              type="number"
              label="mm"
              style="top: 59.3%;left: 38.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.f"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) F"
              :class="{ error: errors.has('(Schéma) F') }"
              outlined
              type="number"
              label="mm"
              style="top: 57.3%;left: 56.9%;"
              height="100%"
            />
            <v-text-field
              v-model="form.g"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) G"
              :class="{ error: errors.has('(Schéma) G') }"
              outlined
              type="number"
              label="mm"
              style="top: 45.5%;left: 66.5%;"
              height="100%"
            />
            <v-text-field
              v-model="form.h"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) H"
              :class="{ error: errors.has('(Schéma) H') }"
              outlined
              type="number"
              label="mm"
              style="top: 75.4%;left: 62.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.i"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) I"
              :class="{ error: errors.has('(Schéma) I') }"
              outlined
              type="number"
              label="mm"
              style="top: 33.3%;left: 77.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.j"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) J"
              :class="{ error: errors.has('(Schéma) J') }"
              outlined
              type="number"
              label="mm"
              style="top: 16.5%;left: 90.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.k"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) K"
              :class="{ error: errors.has('(Schéma) K') }"
              outlined
              type="number"
              label="mm"
              style="top: 89.8%;left: 12.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.l"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) L"
              :class="{ error: errors.has('(Schéma) L') }"
              outlined
              type="number"
              label="mm"
              style="top: 89.8%;left: 25.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.m"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) M"
              :class="{ error: errors.has('(Schéma) M') }"
              outlined
              type="number"
              label="mm"
              style="top: 89.8%;left: 38.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.n"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) N"
              :class="{ error: errors.has('(Schéma) N') }"
              outlined
              type="number"
              label="mm"
              style="top: 89.8%;left: 51.3%; width: 45.7%"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
      justify-center
      mt-8
      mb-8
    >
      <v-flex
        column
        sm6
      >
        <v-layout
          v-for="(article, index) in articlesList"
          :key="index"
          class="checkbox-input-container"
        >
          <v-flex>
            <v-checkbox
              v-if="form.articles[index]"
              v-model="form.articles[index].idc_want"
              :label="article.label"
              hide-details
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex
            v-if="article.idc_entry"
            class="checkbox-input visible"
          >
            <InputNumber
              v-if="form.articles[index]"
              v-model="form.articles[index].value"
              class="input-number"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mb-5
    >
      <v-flex sm6>
        <v-textarea
          v-model="form.fitting"
          filled
          hide-details
          name="Pour l'essayage :"
          label="Pour l'essayage :"
        />
      </v-flex>

      <v-flex sm6>
        <v-textarea
          v-model="form.finishing"
          filled
          hide-details
          name="Pour la finition :"
          label="Pour la finition :"
        />
      </v-flex>
    </v-layout>

    <v-flex
      column
      sm12
    >
      <v-textarea
        v-model="form.comment"
        filled
        hide-details
        name="Commentaires divers :"
        label="Commentaires divers :"
      />
    </v-flex>
  </div>
</template>

<script>
import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "PositioninSeatStepOne",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  async mounted() {
    await this.loadArticles("POSITIONING_SEAT");

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.positioning-seat-step-one {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 10.1%;
        height: 8.6%;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
